import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HERO_SLIDES } from '../constants';
import { Fingerprint, ArrowRight } from 'lucide-react';

export const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div id="home" className="relative h-screen w-full overflow-hidden bg-gray-900">
      {/* Slides */}
      {HERO_SLIDES.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          {/* Image Overlay */}
          <div className="absolute inset-0 bg-black/40 z-10" />
          <img
            src={slide.image}
            alt={slide.title}
            className={`w-full h-full object-cover transition-transform duration-[10000ms] ease-out ${
                index === currentSlide ? 'scale-110' : 'scale-100'
            }`}
          />
          
          {/* Content */}
          <div className="absolute inset-0 z-20 flex flex-col items-center justify-center pt-20">
            <div className="text-center px-4 max-w-5xl mx-auto">
              <div 
                className={`transition-all duration-1000 delay-300 transform flex flex-col items-center ${
                  index === currentSlide 
                    ? 'translate-y-0 opacity-100 blur-none' 
                    : 'translate-y-8 opacity-0 blur-sm'
                }`}
              >
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 leading-none shadow-lg tracking-tight">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-2xl text-white font-light tracking-wide mb-10 opacity-90 max-w-3xl">
                  {slide.subtitle}
                </p>
                
                <div className="flex flex-col sm:flex-row justify-center gap-4 w-full px-4">
                  <Link 
                      to={slide.sectionId === 'products' ? '/products' : '/about'}
                      className="inline-flex justify-center items-center gap-3 border-2 border-white text-white px-6 md:px-10 py-3 text-base md:text-lg font-heading font-semibold uppercase tracking-widest hover:bg-white hover:text-avo-forest transition-all duration-300 group w-full sm:w-auto"
                    >
                      Discover More
                      <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Quality Oil Badge - Bottom Left */}
      <div className="absolute bottom-8 left-4 md:bottom-10 md:left-10 z-30 inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/50 bg-black/30 backdrop-blur-md shadow-[0_0_15px_rgba(255,255,255,0.2)]">
        <Fingerprint className="text-white w-3 h-3 md:w-4 md:h-4" />
        <span className="text-white text-[10px] md:text-xs font-bold tracking-widest uppercase drop-shadow-md">Quality Oil For You</span>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-8 right-4 md:bottom-10 md:right-10 z-30 flex justify-end px-4">
         <div className="flex flex-wrap justify-end gap-2 max-w-full">
            {HERO_SLIDES.map((_, index) => (
            <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-1.5 rounded-full transition-all duration-500 ${
                index === currentSlide ? 'bg-white w-8 opacity-100' : 'bg-white/40 w-4 opacity-60 hover:opacity-100'
                }`}
                aria-label={`Go to slide ${index + 1}`}
            />
            ))}
        </div>
      </div>

    </div>
  );
};